/**
 * Video Player Component
 *
 * Plays a JSON array of video paths sequentially on loop (muted autoplay).
 * Listens for `sc:panelopen` so players injected via template also initialise.
 */

(function (): void {
    function initPlayers(root: Document | HTMLElement): void {
        root.querySelectorAll<HTMLElement>('.vp-player:not([data-vp-ready])').forEach(function (player) {
            const video   = player.querySelector<HTMLVideoElement>('.vp-video');
            const bar     = player.querySelector<HTMLElement>('.vp-bar');
            const counter = player.querySelector<HTMLElement>('.vp-counter');
            if (!video) return;

            let videos: string[] = [];
            try { videos = JSON.parse(player.dataset.videos || '[]'); } catch { return; }
            if (videos.length === 0) return;

            player.setAttribute('data-vp-ready', '');
            let current = 0;

            function load(index: number): void {
                current = ((index % videos.length) + videos.length) % videos.length;
                video!.src = encodeURI(videos[current]);
                video!.load();
                video!.play().catch(function () {});
                if (counter) {
                    counter.textContent = videos.length > 1 ? `${current + 1} / ${videos.length}` : '';
                }
            }

            video.addEventListener('ended', function () { load(current + 1); });
            video.addEventListener('timeupdate', function () {
                if (!bar || !video.duration) return;
                bar.style.width = `${(video.currentTime / video.duration) * 100}%`;
            });

            load(0);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { initPlayers(document); });
    } else {
        initPlayers(document);
    }

    // Re-init after solution-card injects template content
    document.addEventListener('sc:panelopen', function () { initPlayers(document); });
})();
